import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrashOutlined = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M1.5 2.5H10.5A0.5 0.5 0 0 1 10.5 3.5H1.5A0.5 0.5 0 0 1 1.5 2.5Z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M10 3V9.6A1.9 1.9 0 0 1 8.1 11.5H3.9A1.9 1.9 0 0 1 2 9.6V3A0.5 0.5 0 0 1 3 3V9.6A0.9 0.9 0 0 0 3.9 10.5H8.1A0.9 0.9 0 0 0 9 9.6V3A0.5 0.5 0 0 1 10 3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M8.5 3V2A1.5 1.5 0 0 0 7 0.5H5A1.5 1.5 0 0 0 3.5 2V3A0.5 0.5 0 0 0 4.5 3V2A0.5 0.5 0 0 1 5 1.5H7A0.5 0.5 0 0 1 7.5 2V3A0.5 0.5 0 0 0 8.5 3Z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M4.5 5.75A0.5 0.5 0 0 1 5.5 5.75V8.25A0.5 0.5 0 0 1 4.5 8.25Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.5 5.75A0.5 0.5 0 0 1 7.5 5.75V8.25A0.5 0.5 0 0 1 6.5 8.25Z" })
	]
});
export default SvgTrashOutlined;
